import { useQuery } from "@tanstack/react-query";
import { type DocumentDetail, DocumentStatus } from "@/briefpoint-client";
import { useDocumentApi } from "@/hooks/useApi";
import { getProcessingDocumentsOptions } from "@/lib/query-options";
import type { DocumentClient } from "@/lib/types";
import { addUploadDate } from "@/lib/utils";
import ProcessingBox from "./ProcessingBox";

interface Props {
  uploadingDocuments: DocumentClient[];
}

export default function ProcessingBoxList(props: Props) {
  const documentApi = useDocumentApi();
  const documentsQueryPolling = useQuery({
    ...getProcessingDocumentsOptions(documentApi),
    select: (data) =>
      data
        .filter(
          (document) =>
            document.status < DocumentStatus.Processed ||
            document.status === DocumentStatus.Error ||
            document.status === DocumentStatus.Processed,
        )
        .sort((a, b) => {
          if (a.uploadDate && b.uploadDate && a.uploadDate < b.uploadDate)
            return 1;
          if (a.uploadDate && b.uploadDate && a.uploadDate > b.uploadDate)
            return -1;
          return a.id.localeCompare(b.id);
        })
        .map((document) => addUploadDate(document as DocumentDetail)),
    refetchInterval: (query) => {
      /* refetch every 1 second if there are documents that are not complete */
      const notComplete = query.state.data?.filter(
        (document) => document.status < DocumentStatus.Processed,
      );
      if (!notComplete || notComplete.length === 0) return false;
      return 1000;
    },
  });

  return (
    <div>
      {props.uploadingDocuments
        .concat(documentsQueryPolling.data ?? [])
        .map((document) => (
          <ProcessingBox
            key={document.id}
            document={document}
            uploading={props.uploadingDocuments.some(
              (d) => d.id === document.id,
            )}
          />
        ))}
    </div>
  );
}
